import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint, MustPreloadLoadableNames } from '@confluence/loadable';

export const ViewPageRouteComponentLoader: LoadableType<{
	spaceKey: any;
	contentId: any;
	isPage: any;
	isMobile: any;
	isEmbeddedConfluence: any;
}> = LoadablePaint({
	// Name is used in next/packages/view-page/src/index.ts must match
	name: MustPreloadLoadableNames.ViewPageRouteComponentLoader,
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ViewPageRouteComponent" */ './ViewPageRouteComponent.tsx'
			)
		).ViewPageRouteComponent,
});
